export default __webpack_public_path__ + "static/media/george.04a1c33d.jpg";